<template>
  <div
    class="counselor-grid__filter"
    :class="{
      'counselor-grid__filter--visible':
        (isMobile || isTablet) && filtersAreVisible,
    }"
  >
    <div class="counselor-grid__filter-header counselor-grid__section-header">
      <h2 v-text="texts.refineSearch" />
      <p v-text="numberOfFiltersText" />
      <button
        class="counselor-grid__filter-close"
        v-if="isMobile || isTablet"
        :aria-label="texts.close"
        @click.prevent="toggleFiltersVisibility"
      >
        <icon-close />
      </button>
    </div>
    <div class="counselor-grid__filter-wrapper">
      <competence-area-filter
        v-if="isTherapy || role === 'lawyer'"
        :role="role"
      />
      <type-of-meeting-filter />
      <location-filter v-if="!isTherapy" />
      <places-filter v-if="isTherapy" :is-city-page="isCityPage" />
      <available-times-filter v-if="isTherapy" />
      <language-filter :users="users" />
      <years-of-experience-filter />
      <gender-filter v-if="isTherapy" />
      <title-filter v-if="isTherapy" />
      <target-group-filter v-if="isTherapy" />
      <accreditation-filter v-if="isTherapy" />
    </div>
    <div class="counselor-grid__filter-footer">
      <button
        class="counselor-grid__filter-clear btn"
        @click.prevent="clearFilters"
        v-text="texts.clearFilters"
      />
      <button
        class="counselor-grid__filter-show-results btn btn-cta"
        v-if="isMobile || isTablet"
        @click.prevent="toggleFiltersVisibility"
        v-text="texts.showResults"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { useIsMobile } from 'Main/composables/useIsMobile';
import { hasTherapyRole } from 'Main/contact-form/constants';
import IconClose from 'Main/icons-vue/IconClose.vue';
import { sprintf } from 'sprintf-js';
import { defineComponent } from 'vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import AccreditationFilter from './filters/AccreditationFilter.vue';
import AvailableTimesFilter from './filters/AvailableTimesFilter.vue';
import CompetenceAreaFilter from './filters/CompetenceAreaFilter.vue';
import GenderFilter from './filters/GenderFilter.vue';
import LanguageFilter from './filters/LanguageFilter.vue';
import LocationFilter from './filters/LocationFilter.vue';
import PlacesFilter from './filters/PlacesFilter.vue';
import TargetGroupFilter from './filters/TargetGroupFilter.vue';
import TitleFilter from './filters/TitleFilter.vue';
import TypeOfMeetingFilter from './filters/TypeOfMeeting.vue';
import YearsOfExperienceFilter from './filters/YearsOfExperienceFilter.vue';

export default defineComponent({
  components: {
    AccreditationFilter,
    AvailableTimesFilter,
    CompetenceAreaFilter,
    GenderFilter,
    IconClose,
    LanguageFilter,
    LocationFilter,
    PlacesFilter,
    TargetGroupFilter,
    TitleFilter,
    TypeOfMeetingFilter,
    YearsOfExperienceFilter,
  },

  computed: {
    ...mapState('users', ['users', 'isLoading']),
    ...mapState('counselorGrid', ['filtersAreVisible']),
    ...mapGetters('counselorGrid', ['numOfSetFilters']),

    isTherapy() {
      return hasTherapyRole(this.role);
    }, 

    numberOfFiltersText() {
      if (this.numOfSetFilters === 1) {
        return this.texts.oneFilterApplied;
      }

      return sprintf(this.texts.numberOfFiltersApplied, this.numOfSetFilters);
    }
  },

  created() {
    this.syncCompetenceAreas();
  },

  data() {
    return {
      texts: window.theme_vars.counselorGridTexts,
    };
  },

  methods: {
    ...mapActions('counselorGrid', ['clearFilters', 'toggleFiltersVisibility']),

    async syncCompetenceAreas() {
      await this.$store.dispatch('counselorGrid/syncCompetenceAreas', {
        role: this.role,
      });
    },
  },

  props: {
    country: {
      default: '',
      type: String,
    },
    isCityPage: {
      default: false,
      type: Boolean,
    },
    role: {
      required: true,
      type: String,
    },
  },

  setup() {
    const { isMobile, isTablet } = useIsMobile();
    return { isMobile, isTablet };
  },
});
</script>
